// Tipologie Sinistro/Pratica configurabili da Impostazioni Studio.
// Usate ovunque: wizard nuova pratica, filtri Gestione Pratiche, modelli lettera, ecc.
import api from "./api";

export const DEFAULT_TIPOLOGIE_SINISTRO = [
  { code: "RD", label: "RISARCIMENTO DIRETTO" },
  { code: "RCA", label: "RESPONSABILITA CIVILE AUTO" },
  { code: "T-TRA", label: "LESIONI TERZI TRASPORTATI" },
  { code: "RCD", label: "RESPONSABILITA CIVILE DIVERSI" },
  { code: "INF-L", label: "INFORTUNIO SU LAVORO" },
  { code: "P-INF", label: "POLIZZA INFORTUNI" },
  { code: "ARD", label: "ALTRI RISCHI DIVERSI" },
  { code: "OUT", label: "OUT SOURCING" },
  { code: "PREV", label: "PERIZIA" },
  { code: "MLS", label: "MALASANITA'" },
  { code: "P-MAL", label: "POLIZZA MALATTIA" },
  { code: "CONTRATTI", label: "UNIGESTPRO" },
  { code: "PP.", label: "PROCEDIMENTO PENALE" },
  { code: "POLIZZE VCL", label: "POLIZZA VEICOLI" },
  { code: "PP.AVV.", label: "PRATICA PASSATA PER LETTERA" },
  { code: "PI.24H", label: "RILIEVI PRONTO INTERVENTO 24H" },
  { code: "R.R.AUTORITA", label: "RICH.RAPPAUTORITA" },
  { code: "PER/PREV.AUTO", label: "PERIZIA/PREVENTIVO AUTO" },
  { code: "DIFF.CONCE.GARANZIA", label: "DIFF.CONCESSIONARIO" },
  { code: "RESP.MEDICA", label: "RESPONSABILITA MEDICA" },
];

// Normalizza qualsiasi valore salvato in [{code,label}].
export function normTipologie(raw) {
  if (!Array.isArray(raw) || !raw.length) return DEFAULT_TIPOLOGIE_SINISTRO;
  const out = [];
  for (const t of raw) {
    if (typeof t === "string") {
      const c = t.trim();
      if (c) out.push({ code: c, label: c, color: "", veicolo: true, solo_prof: false });
    } else if (Array.isArray(t) && t[0]) {
      out.push({ code: String(t[0]).trim(), label: String(t[1] || t[0]).trim(), color: "", veicolo: true, solo_prof: false });
    } else if (t && t.code) {
      out.push({ code: String(t.code).trim(), label: String(t.label || t.code).trim(), color: t.color || "", veicolo: t.veicolo !== false, solo_prof: !!t.solo_prof });
    }
  }
  return out.length ? out : DEFAULT_TIPOLOGIE_SINISTRO;
}

let _cache = null;
export async function fetchTipologie() {
  if (_cache) return _cache;
  try {
    const { data } = await api.get("/studio/me");
    _cache = normTipologie(data?.settings?.tipologie_sinistro);
  } catch { _cache = DEFAULT_TIPOLOGIE_SINISTRO; }
  return _cache;
}
export function clearTipologieCache() { _cache = null; }

export const asPairs = (list) => (list || []).map((t) => [t.code, t.label]);
export const asSel = (list) => (list || []).map((t) => ({ v: t.code, l: t.label && t.label !== t.code ? `${t.code} · ${t.label}` : t.code }));
export const asColorMap = (list) => Object.fromEntries((list || []).filter((t) => t.color).map((t) => [t.code, t.color]));
// Flag per tipologia: veicolo (mostra dati veicolo) e soloProf (tipo senza veicolo, solo professionisti).
export function tipoFlags(list, code) {
  const t = (list || []).find((x) => x.code === code);
  const soloProf = !!t?.solo_prof;
  return { veicolo: !soloProf && t?.veicolo !== false, soloProf };
}
export function contrastText(hex) {
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) return "#ffffff";
  const h = hex.slice(1);
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#0a0d14" : "#ffffff";
}
